import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

function Inscription() {
  const [pseudo, setPseudo] = useState("");
  const [password, setMotDePasse] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    
    const baseUserUrl = process.env.REACT_APP_API_USER_URL;
    const baseAdminUrl = process.env.REACT_APP_API_ADMIN_URL;

    console.log("🟡 Tentative d'inscription...");
    const response = await fetch(`${baseUserUrl}/api/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ pseudo, password })
    });

    if (!response.ok) {
      const error = await response.text();
      console.error("🔴 Erreur inscription :", error);
      alert("Erreur lors de l’inscription");
      return;
    }
    
    if (response.ok) {
      const userData = await response.json();
      login(userData);
      console.log("🟢 Inscription réussie :", userData);
      // Étape 1 : Récupérer tous les murs de l’API admin
      console.log("🟡 Récupération des murs admin...");
      const mursResponse = await fetch(`${baseAdminUrl}/MurDeBrique`);
      const murs = await mursResponse.json();
      console.log("📄 murs :", murs);
      console.log(`🔵 ${murs.length} murs récupérés.`);
      // Étape 2 : Pour chaque mur, récupérer ses formes et les copier dans l’API utilisateur
     await Promise.all(
  murs.map(async (mur) => {
    console.log(`🟡 Récupération du détail du mur ID ${mur.id}`);
    const detailsResponse = await fetch(`${baseAdminUrl}/MurDeBrique/${mur.id}`);
    const details = await detailsResponse.json();
    console.log("📦 details:", details);
    
    const murPayload = {
      nom: details.nom,
      userId: userData.id,
      origineAdminId: mur.id,
      briques: details.briques.map(b => ({
        id: b.formId,
        posX: b.posX,
        posY: b.posY,
      })),
    };

    console.log("🔍 origineAdminId ?", mur.id);
console.log("📦 murPayload complet :", JSON.stringify(murPayload, null, 2));
    
    console.log("🧱 Envoi du mur copié :", murPayload);

    await fetch(`${baseUserUrl}/murs`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(murPayload),
    });
  })
);

await new Promise(resolve => setTimeout(resolve, 2000));
console.log("⏳ Fin de l'attente avant navigation");
    
      navigate("/murs");
    } else {
      alert("Erreur lors de l’inscription");
    }
  };
  return (
    <div className="form-container retro-form">
      <h2>Créer un compte</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="Pseudo"
          value={pseudo}
          onChange={(e) => setPseudo(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Mot de passe"
          value={password}
          onChange={(e) => setMotDePasse(e.target.value)}
          required
        />
        <button type="submit" className="retro-btn">S’inscrire</button>
      </form>
    </div>
  );
}


export default Inscription;
